import { render, staticRenderFns } from "./popCompositionMultiAdd.vue?vue&type=template&id=72d0acd1&"
import script from "./popCompositionMultiAdd.vue?vue&type=script&lang=js&"
export * from "./popCompositionMultiAdd.vue?vue&type=script&lang=js&"
import style0 from "./popCompositionMultiAdd.vue?vue&type=style&index=0&id=72d0acd1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports